module.exports = __webpack_public_path__ + "img/page-02.44126bd6.jpg";